import { Component, Input } from '@angular/core';
import { Router } from '@angular/router';
import { ClientSettingViewModel } from '../../../core/api/models';
import { DomSanitizer } from '@angular/platform-browser';
import { environment } from '../../../../environments/environment';
import { ClientsApiService } from '../../../core/api/services';
import { Utils } from '../../../core/utils';

@Component({
  selector: 'app-client-details-navigation',
  templateUrl: './client-details-navigation.component.html',
  styleUrl: './client-details-navigation.component.css',
  standalone: false
})
export class ClientDetailsNavigationComponent {
  @Input({ required: true }) clientID!: number | undefined;

  currentItem?: ClientSettingViewModel;


  constructor(private apiService: ClientsApiService,
    private sanitizer: DomSanitizer,
    private router: Router) {

  }

  ngOnInit(): void {
    
    if (this.clientID) {
      this.apiService.GetClientSettings({ body: { clientID: this.clientID } })
        .forEach(data => {
          this.currentItem = data;


        }).catch(
          err => {

          });
    }
  }

  clickItem(item: string) {
    this.router.navigate([`/clients/${this.currentItem?.ClientID}/${item}`]);

  }

  getClientLogo(client: ClientSettingViewModel | null | undefined, type: string = 'Print'): any {

    var siteName = client?.SiteName?.toLocaleLowerCase();
    if (siteName == 'optodev' || siteName == 'utbs')
      siteName = 'beta';

    //return this.sanitizer.bypassSecurityTrustUrl(`https://${siteName}.${environment.baseDomain}/Login/DisplayLogo/${siteName}.png`);
    return this.sanitizer.bypassSecurityTrustUrl(`https://${siteName}.${environment.baseDomain}/Login/${type}Logo/${siteName}.png`);
  }

}
